import {createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import reducers, {initialState} from './reducers'

let enhancer = applyMiddleware(thunk)

let store = createStore(reducers, initialState, enhancer)

export default store


// WEBPACK FOOTER //
// ./src/redux/index.js